"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _theme = require("../../../theme");
var useStyles = (0, _theme.makeStyles)(function (_ref) {
  var shadows = _ref.shadows,
    background = _ref.background,
    _ref$palette = _ref.palette,
    primary = _ref$palette.primary,
    text = _ref$palette.text,
    typography = _ref.typography,
    shade = _ref.utils.shade;
  var padding = '42px';
  return {
    paper: {
      padding: '70px 0 0 0',
      overflowY: 'visible'
    },
    shapeButton: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxShadow: shadows[1],
      borderRadius: '10px',
      zIndex: 10
    },
    closeButton: {
      position: 'absolute',
      top: 18,
      right: 24,
      fontSize: '15px',
      lineHeight: '18px',
      width: 39,
      height: 39,
      cursor: 'pointer',
      borderRadius: '20px',
      backgroundColor: background.primary
    },
    header: {
      padding: "0 ".concat(padding),
      marginBottom: 23,
      position: 'relative',
      zIndex: 1
    },
    icon: {
      width: 52,
      height: 52,
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      left: -26,
      fontSize: '20px',
      lineHeight: '25px',
      color: primary.contrastText,
      backgroundColor: primary.main
    },
    headerTitle: {
      display: 'flex'
    },
    extra: {
      marginLeft: 'auto',
      flexShrink: 0
    },
    title: {
      margin: '0 0 9px',
      fontSize: '24px',
      lineHeight: '33px',
      fontWeight: typography.fontWeightSemiBold
    },
    subTitle: {
      color: shade(text.primary, 6),
      fontSize: '13px',
      lineHeight: '18px',
      fontWeight: typography.fontWeightRegular,
      margin: 0
    },
    content: {
      padding: "0 ".concat(padding),
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
      overflowY: 'auto'
    },
    holder: {
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
      paddingBottom: padding
    },
    topBar: {
      position: 'absolute',
      top: 19,
      left: 46,
      right: 76
    }
  };
}, {
  name: 'ActionDrawer'
});
exports.useStyles = useStyles;